import { api } from '@/services/api';
import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import { AxiosError } from 'axios';
import { AxiosErrorResponse } from '@/@types/Errors';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@/auth/Auth';

export interface AcceptAccountInviteData {
  token: string;
  email: string;
}

export const useAcceptAccountInvite = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const { t } = useTranslation('invitationAcceptInvite');
  const { replaceSession } = useAuth();

  const { mutate, isPending: isAccepting } = useMutation({
    mutationFn: async (data: AcceptAccountInviteData) => {
      const response = await api.post(`/v1/invites/${data.token}/accept`);
      return response.data;
    },
    onSuccess: async (data) => {
      localStorage.removeItem('redirectAfterEmailVerification');

      // Back-end retorna token contextualizado para a loja do convite
      const newToken = data?.token;
      if (newToken) {
        await replaceSession(newToken);
        navigate('/dashboard', { replace: true });
        return;
      }

      navigate('/invitation-accept-confirm');
    },
    onError: (error: AxiosError<AxiosErrorResponse>) => {
      toast({
        variant: 'error',
        description: error?.response?.data?.message || t('error'),
      });
    },
  });

  return {
    acceptInvite: mutate,
    isAccepting,
  };
};
